// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import React from 'react';
import styled from 'styled-components';
import Icon from '../../../components/Icon';
import BadgeIconImage from '../../../assets/images/badge-icon-header.svg'
import BellIcon from '../../../assets/images/bell.svg';
import BellActiveIcon from '../../../assets/images/bell-active.svg';

interface BadgeIconProps extends React.ComponentPropsWithRef<'div'> {
  unread: boolean;
  active?: boolean;
}

const S = {
  Container: styled.div`
    display: flex;
    position: relative;
    height: 32px;
  `,
  BellIcon: styled(Icon).attrs({ icon: BellIcon })<{ show?: boolean }>`
    ${props => !props.show ? { display: 'none' } : null }
  `,
  BellActiveIcon: styled(Icon).attrs({ icon: BellActiveIcon })<{ show?: boolean }>`
    ${props => !props.show ? { display: 'none' } : null }
  `,
  BadgeNumber: styled.img.attrs({ src: BadgeIconImage})`
    position: absolute;
    left: calc(100% - 12px);
    top: 5px;
  `
}

const NotificationIcon: React.FC<BadgeIconProps> = ({ active, unread, ...props }) => {
  return (
    <S.Container {...props}>
      <S.BellIcon show={!active} />
      <S.BellActiveIcon show={active}/>
      {unread && <S.BadgeNumber />}
    </S.Container>
  )
}

export { NotificationIcon as default }
